if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        console.log(this)
        // Use event delegation for dynamically added links
        this.addEventListener('click', (event) => {
          if (event.target.classList.contains('link') && event.target.classList.contains('link--text')) {
            this.onItemClick.call(this, event);
          }
        });

        this.hidePanel = this.hidePanel.bind(this);
        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.openSelector = this.openSelector.bind(this);
        this.closeSelector = this.closeSelector.bind(this);
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if(this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const selectedLocale = event.target.dataset.locale;
        // Get current path and query
        let path = window.location.pathname;
        // Remove existing locale prefix (en or de)
        path = path.replace(/^\/(en|de)(\/|$)/, '/');
        const search = window.location.search;

        let newUrl;
        if (selectedLocale === 'de') {
          newUrl = 'https://www.texelana.com/de' + path + search;
        } else if (selectedLocale === 'en') {
          newUrl = 'https://www.texelana.com' + path + search;
        } else {
          // Default: Dutch
          newUrl = 'https://www.texelana.nl' + path + search;
        }
        window.location.href = newUrl;
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) { 
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
                    // Delay hiding the panel to allow click events to process (fixes iOS/Safari issue)
          setTimeout(() => {
            this.hidePanel();
          }, 100);
        }
      }
    }
  );
}
